/* src/app/components/controls/sem-bound-label/sem-bound-label.component.css */
/*# sourceMappingURL=sem-bound-label.component.css.map */
